import { DatePicker, Input, Table, Modal, Button, InputNumber } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate, coinDivideFormat, coinMultiFormat } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

class BbtUsdtStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    this.getData();
  }
  getData = () => {
    httpGet(httpUrl.bbtUsdtStatus,[],{}).then((res) => {
      this.setState({data: res.data})

    });
  };

  render() {
    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          
          <div className="flex-row flex-center flex-end m-b-10">
          </div>
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
          </div>
          <div style={{fontSize: '20px'}}>
            회원보유 총 USDT: {amountFormat(this.state.data.usdtTotal, 402)} USDT<br/>
            회원보유 총 분배USDT: {amountFormat(this.state.data.divUsdtTotal, 403)} USDT<br/><br/>

            분배USDT 보유 총 지갑수: {this.state.data.divUsdtCount} 개<br/>
            최소출금수량 이상 보유 지갑수: {this.state.data.divUsdtOverMinCount} 개<br/>
            최소출금수량 이상 보유 지갑의 총액: {amountFormat(this.state.data.divUsdtOverMinTotal, 403)} USDT
          </div>
      </div>
    );
  }
}

export default BbtUsdtStatus;
